export default __webpack_public_path__ + "static/media/eye-on.e54125a9.svg";